import React from "react";
import { Link } from "react-router-dom";
import { Toaster } from "sonner";
import MockupForm from "@/components/admin/MockupForm";
import {
  getCurrentUser,
  handleUnauthorized,
} from "@/lib/auth";

export default function AdminMockupEdit({
  staffMode = false,
}) {
  const currentUser = getCurrentUser();

  const expectedRole = staffMode ? "staff" : "owner";
  const backUrl = staffMode
    ? "/staff/mockups"
    : "/admin/mockups";

  React.useEffect(() => {
    if (
      !currentUser ||
      currentUser.role !== expectedRole
    ) {
      handleUnauthorized();
    }
  }, [currentUser, expectedRole]);

  if (
    !currentUser ||
    currentUser.role !== expectedRole
  ) {
    return null;
  }

  return (
    <div
      className="min-h-screen bg-[#09090B] text-white font-body"
      data-testid="admin-edit-page"
    >
      <header className="sticky top-0 z-40 border-b border-white/5 bg-[#09090B]/80 backdrop-blur-xl">
        <div className="mx-auto flex h-14 max-w-4xl items-center justify-between px-6 md:px-10">
          <Link
            to={backUrl}
            className="flex items-center gap-2"
            data-testid="admin-edit-back"
          >
            <span className="inline-flex h-6 w-6 items-center justify-center rounded bg-[#00E5FF] text-xs font-bold text-black">
              T
            </span>

            <span className="text-sm font-semibold">
              TapToTable{" "}
              <span className="font-normal text-zinc-500">
                · {staffMode ? "staff" : "admin"}
              </span>
            </span>
          </Link>

          <div className="text-xs text-zinc-400">
            Signed in as{" "}
            <span className="text-white">
              {currentUser.name}
            </span>
          </div>
        </div>
      </header>

      <main className="mx-auto max-w-4xl px-6 py-10 md:px-10">
        <div className="text-[10px] font-bold uppercase tracking-[0.2em] text-[#00E5FF]">
          Restaurant Page
        </div>

        <h1 className="mt-1 mb-8 text-3xl font-semibold">
          Edit Page & Outreach
        </h1>

        <MockupForm
          mode="edit"
          staffMode={staffMode}
        />
      </main>

      <Toaster
        theme="dark"
        position="top-center"
      />
    </div>
  );
}
